export default __webpack_public_path__ + "static/media/twitter.d7450657.svg";